module.exports = __webpack_public_path__ + "static/media/iphone-frame.bf040ce0.png";